<div class="notification-item card border-0" [ngClass]="{ 'p-0 toaster': isNotificationToaster }">
  <ng-container *ngIf="!!notification.messageLanguage">
    <ng-container *ngIf="isNotificationToaster; else notificationItem">
      <div class="d-flex justify-content-between align-items-center">
        <img
          src="{{ notification.image ? (notification.image | contentImage: '1') : 'assets/images/notification_placeholder.png' }}"
        />
        <div class="toaster-notification-message">
          {{ notification.messageLanguage?.message }}
        </div>
        <a (click)="removeNotification.emit()" class="close-btn-toast">
          <span class="material-symbols-outlined">close</span>
        </a>
      </div>
      <div class="d-flex justify-content-end">
        <!-- Notification Link -->
        <ng-container *ngIf="notification.messageLanguage?.linkText">
          <ng-container [ngSwitch]="notification.actionType">
            <a
              class="toaster-notification-links d-flex align-items-center justify-content-center"
              *ngSwitchCase="actionType.InternalLink"
              [routerLink]="notification.linkUrl || notification.action"
              (click)="goToNotification.emit()"
            >
              <span class="toaster-notification-link-url">{{ notification.messageLanguage?.linkText }}</span>
            </a>

            <a
              class="toaster-notification-links d-flex align-items-center justify-content-center"
              *ngSwitchCase="actionType.ExternalLink"
              [href]="notification.linkUrl || notification.action"
              target="_blank"
              rel="noopener"
              (click)="goToNotification.emit()"
            >
              <span class="toaster-notification-link-url">{{ notification.messageLanguage?.linkText }}</span>
            </a>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #notificationItem>
      <div class="row">
        <div class="col-2">
          <img
            src="{{
              notification.image ? (notification.image | contentImage: '1') : 'assets/images/notification_placeholder.png'
            }}"
          />
        </div>
        <div class="col-10">
          <div class="notification-message">
            {{ notification.messageLanguage?.message }}
          </div>
          <div class="d-flex justify-content-between">
            <div class="time"><fgbcl-time-since [startDate]="notification.messageDate"></fgbcl-time-since></div>
            <!-- Notification Link -->
            <ng-container [ngSwitch]="notification.actionType">
              <a
                class="notification-links d-flex align-items-center"
                *ngSwitchCase="actionType.InternalLink"
                [routerLink]="notification.linkUrl || notification.action"
                (click)="goToNotification.emit()"
              >
                <span class="notification-link-url">{{ notification.messageLanguage?.linkText }}</span>
                <span class="material-icons notification-icon"> chevron_right </span>
              </a>

              <a
                class="notification-links d-flex align-items-center"
                *ngSwitchCase="actionType.ExternalLink"
                [href]="notification.linkUrl || notification.action"
                target="_blank"
                rel="noopener"
                (click)="goToNotification.emit()"
              >
                <span class="notification-link-url">{{ notification.messageLanguage?.linkText }}</span>
                <span class="material-icons notification-icon"> chevron_right </span>
              </a>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>
